<template>
  <b-modal
    ref="exportToFileModal"
    centered
    title="Eksport do pliku"
    size="lg"
    :visible="exportToFileWindowVisible"
    @hidden="hide"
    @show="onShow"
  >
    <b-form>
      <div class="alert alert-danger" role="alert" v-show="showAlert">
        <strong>Uwaga.</strong> Formularz zawiera błędy.
      </div>
      <div
        class="alert alert-danger"
        role="alert"
        v-show="!hasPermissionExportData"
      >
        <strong>Uwaga.</strong> Użytkownik nie ma uprawnień do eksportu danych.
      </div>
      <div class="alert alert-info" role="alert" v-show="!exportAvailable">
        <strong>Informacja.</strong> Eksport danych nie jest dostępny.
        <span v-if="nextExportDateText"
          >Najbliższa dostępna data eksportu: {{ nextExportDateText }}.</span
        >
      </div>
      <b-form-row v-show="dataErrors.scopeIsEmpty" id="scope-error-info">
        <b-col offset-md="3" md="7">
          <small class="text-danger">Należy wybrać zakres.</small>
        </b-col>
      </b-form-row>
      <b-form-group
        horizontal
        :label-cols="3"
        breakpoint="md"
        v-if="!historyTab"
        label="Zakres"
        label-for="scope"
      >
        <b-form-select
          v-model="exportData.scope"
          id="scope"
          :disabled="locked"
          :class="{
            'is-invalid': dataErrors.scopeIsEmpty,
            'form-control': true
          }"
        >
          <option :value="null">Wybierz</option>
          <option :value="scopes.selection">Zaznaczenie</option>
          <option :value="scopes.all">Wszystko</option>
        </b-form-select>
        <small v-if="showSelectedFeaturesAmount" class="form-text text-muted"
          >Liczba zaznaczonych obiektów: {{ selectedMapFeatures.size }}</small
        >
      </b-form-group>
      <b-form-row
        v-show="dataErrors.voivodeshipIsEmpty"
        id="voivodeship-error-info"
      >
        <b-col offset-md="3" md="7">
          <small class="text-danger">Należy wybrać województwo.</small>
        </b-col>
      </b-form-row>
      <b-form-group
        horizontal
        :label-cols="3"
        breakpoint="md"
        v-if="!historyTab && isAllScopeSelected"
        label="Województwo"
        label-for="voivodeship"
      >
        <b-form-select
          v-model="exportData.voivodeship"
          id="voivodeship"
          :disabled="locked"
          :class="{
            'is-invalid': dataErrors.voivodeshipIsEmpty,
            'form-control': true
          }"
        >
          <option :value="null">Wybierz</option>
          <option
            v-for="voivodeship in voivodeships"
            :key="voivodeship.value"
            :value="voivodeship.value"
            >{{ voivodeship.name }}</option
          >
        </b-form-select>
      </b-form-group>

      <b-form-group
        horizontal
        :label-cols="3"
        breakpoint="md"
        v-if="!historyTab && isAllScopeSelected"
      >
        <b-form-checkbox
          v-model="exportData.allDistricts"
          :disabled="locked || !exportData.voivodeship"
        >
          Wszystkie powiaty
        </b-form-checkbox>
      </b-form-group>

      <b-form-row v-show="dataErrors.districtIsEmpty" id="district-error-info">
        <b-col offset-md="3" md="7">
          <small class="text-danger"
            >Należy wybrać powiat lub zaznaczyć opcję 'Wszystkie
            powiaty'.</small
          >
        </b-col>
      </b-form-row>
      <b-form-group
        horizontal
        :label-cols="3"
        breakpoint="md"
        v-if="!historyTab && isAllScopeSelected"
        label="Powiat"
        label-for="district"
      >
        <b-form-select
          v-model="exportData.district"
          id="district"
          :disabled="
            locked || !exportData.voivodeship || exportData.allDistricts
          "
          :class="{
            'is-invalid': dataErrors.districtIsEmpty,
            'form-control': true
          }"
        >
          <option :value="null">Wybierz</option>
          <option
            v-for="district in districts"
            :key="district.value"
            :value="district.value"
            >{{ district.name }}</option
          >
        </b-form-select>
      </b-form-group>

      <b-form-row v-show="dataErrors.fileTypeIsEmpty" id="file-type-error-info">
        <b-col offset-md="3" md="7">
          <small class="text-danger">Należy wybrać typ pliku.</small>
        </b-col>
      </b-form-row>
      <b-form-group
        horizontal
        :label-cols="3"
        breakpoint="md"
        label="Typ pliku"
        label-for="file-type"
      >
        <b-form-select
          v-model="exportData.fileType"
          id="file-type"
          :disabled="locked || isAllScopeSelected"
          :class="{
            'is-invalid': dataErrors.fileTypeIsEmpty,
            'form-control': true
          }"
        >
          <option :value="null">Wybierz</option>
          <option
            v-for="fileType in fileTypes"
            :key="fileType.value"
            :value="fileType.value"
          >
            {{ fileType.name }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn variant="primary" @click="exportToFile">Eksportuj</b-btn>
      <b-btn variant="outline-secondary" @click="hide">Anuluj</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { WINDOW_EXPORT_TO_FILE_HIDE } from '../store/mutations.type';
import { Api as ApiHarmonogram } from '../api/api-harmonogram-eksportow.js';
import { Api as ApiWarstwy } from '../api/api-warstwy.js';
import { Api as ApiWyszukiwarka } from '../api/api-wyszukiwarka.js';
import SettingsInstance from '../api/SettingsInstance';

import {
  WINDOW_API_ERROR_SHOW,
  WINDOW_NOTIFICATION_SHOW
} from '../store/mutations.type';

import { mapGetters } from 'vuex';

var moment = require('moment');

export default {
  name: 'ExportToFile',
  data: function() {
    return {
      locked: true,
      showAlert: false,
      exportAvailable: true,
      nextExportDateStart: null,
      nextExportDateEnd: null,
      districtControl: null,
      dataErrors: {
        fileTypeIsEmpty: false,
        scopeIsEmpty: false,
        voivodeshipIsEmpty: false,
        districtIsEmpty: false
      },
      exportData: {
        fileType: null,
        scope: null,
        voivodeship: null,
        district: null,
        allDistricts: false
      },
      fileTypes: [
        {
          name: 'GML',
          value: 'GML'
        },
        {
          name: 'DWG',
          value: 'DWG'
        },
        {
          name: 'DXF',
          value: 'DXF'
        },
        {
          name: 'DGN',
          value: 'DGN'
        },
        {
          name: 'Shapefile',
          value: 'ESRI Shapefile'
        }
      ],
      scopes: {
        all: 'all',
        selection: 'selection'
      },
      scheduleDays: {
        1: 'poniedziałek',
        2: 'wtorek',
        3: 'środa',
        4: 'czwartek',
        5: 'piątek',
        6: 'sobota',
        7: 'niedziela'
      },
      voivodeships: [
        {
          name: 'dolnośląskie',
          value: '02'
        },
        {
          name: 'kujawsko-pomorskie',
          value: '04'
        },
        {
          name: 'lubelskie',
          value: '06'
        },
        {
          name: 'lubuskie',
          value: '08'
        },
        {
          name: 'łódzkie',
          value: '10'
        },
        {
          name: 'małopolskie',
          value: '12'
        },
        {
          name: 'mazowieckie',
          value: '14'
        },
        {
          name: 'opolskie',
          value: '16'
        },
        {
          name: 'podkarpackie',
          value: '18'
        },
        {
          name: 'podlaskie',
          value: '20'
        },
        {
          name: 'pomorskie',
          value: '22'
        },
        {
          name: 'śląskie',
          value: '24'
        },
        {
          name: 'świętokrzyskie',
          value: '26'
        },
        {
          name: 'warmińsko-mazurskie',
          value: '28'
        },
        {
          name: 'wielkopolskie',
          value: '30'
        },
        {
          name: 'zachodniopomorskie',
          value: '32'
        }
      ],
      districts: []
    };
  },
  watch: {
    'exportData.scope': function(newVal) {
      if (newVal === this.scopes.all) {
        this.exportData.fileType = 'ESRI Shapefile';
        this.fetchDistricts(this.exportData.voivodeship);
      }
    },
    'exportData.voivodeship': function(newVal) {
      if (this.exportData.scope === this.scopes.all) {
        this.fetchDistricts(newVal);
      }
    }
  },
  computed: {
    nextExportDateText() {
      if (this.nextExportDateStart && this.nextExportDateEnd) {
        return this.nextExportDateStart + ' - ' + this.nextExportDateEnd;
      }
    },
    ...mapGetters([
      'featuresLayer',
      'selectedFeatures',
      'exportToFileWindowVisible',
      'historyTab',
      'historyTable',
      'selectedMapFeatures'
    ]),
    showSelectedFeaturesAmount() {
      return this.exportData.scope === this.scopes.selection;
    },
    hasPermissionExportData() {
      return this.hasPermission('Export_data');
    },
    isAllScopeSelected() {
      return this.exportData.scope === this.scopes.all;
    }
  },
  methods: {
    hide() {
      this.$store.commit(WINDOW_EXPORT_TO_FILE_HIDE);
    },
    resetForm() {
      this.showAlert = false;
      this.exportAvailable = true;
      this.exportData.fileType = null;
      this.exportData.scope = null;
      this.exportData.voivodeship = null;
      this.exportData.district = null;
      this.districts = [];
      this.exportData.allDistricts = false;
      for (var error in this.dataErrors) {
        this.dataErrors[error] = false;
      }
    },
    async onShow() {
      this.locked = true;
      this.resetForm();
      await this.updateExportScheduleInfo();
      this.locked = false;
    },
    async updateExportScheduleInfo() {
      const api = new ApiHarmonogram();
      let self = this;
      let control = new Date().getTime().toString();
      let exportAvailable = false;
      var nextExportDateStart;
      var nextExportDateEnd;

      let response = await api
        .getEksporty({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId
        })
        .catch(function(err) {
          self.$store.commit(WINDOW_API_ERROR_SHOW, err);
        });

      if (response) {
        let dateFormat = 'YYYY-MM-DD';
        let dateTimeFormat = dateFormat + ' ' + 'HH:mm';
        let now = moment();
        let today = now.day();
        var dayOfWeek = today;

        for (var i = 0; i < 7; i++) {
          let scheduleDay = self.scheduleDays[dayOfWeek];
          let schedule = response.body.harmonogram[scheduleDay];

          if (schedule) {
            let scheduleDayStr = moment(now)
              .add(i, 'days')
              .format(dateFormat);
            let scheduleDayStart = moment(
              scheduleDayStr + ' ' + schedule.startTime,
              dateTimeFormat
            );
            let scheduleDayEnd = moment(
              scheduleDayStr + ' ' + schedule.endTime,
              dateTimeFormat
            );

            if (dayOfWeek === today) {
              exportAvailable = now.isBetween(scheduleDayStart, scheduleDayEnd);
            }

            if (exportAvailable) {
              break;
            }

            if (
              scheduleDayStart.isValid() &&
              scheduleDayEnd.isValid() &&
              now.isBefore(scheduleDayEnd)
            ) {
              nextExportDateStart = scheduleDayStart.format(dateTimeFormat);
              nextExportDateEnd = scheduleDayEnd.format(dateTimeFormat);
              break;
            }
          }
          dayOfWeek = (dayOfWeek % 7) + 1;
        }
      }

      self.exportAvailable = exportAvailable;
      self.nextExportDateStart = nextExportDateStart;
      self.nextExportDateEnd = nextExportDateEnd;
    },
    async exportToFile(e) {
      e.preventDefault();

      if (this.locked) {
        return;
      }
      if (this.validateFormData()) {
        await this.updateExportScheduleInfo();

        if (this.exportAvailable && this.hasPermissionExportData) {
          let self = this;
          this.locked = true;
          const api = new ApiWarstwy();

          if (this.isAllScopeSelected) {
            this.hide();

            this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
              type: 'info',
              title: 'Informacja',
              message: 'Trwa eksport danych.',
              duration: 1000000
            });

            if (this.exportData.allDistricts) {
              window.location = this.getVoivodeshipExportPath(
                self.exportData.voivodeship
              );
            } else {
              window.location = this.getDistrictExportPath(
                self.exportData.district
              );
            }
          } else {
            let exportId = await this.getExportId();

            if (exportId) {
              let ready = false;
              var response;

              this.hide();

              this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
                type: 'info',
                title: 'Informacja',
                message: 'Trwa eksport danych.',
                duration: 1000000
              });

              function getExport() {
                let control = Date.now().toString();
                api
                  .getWarstwyWektoroweEksportByEid({
                    wso2_id: this.contextEmail,
                    orgid: this.contextOrganizationId,
                    control: control,
                    eid: exportId
                  })
                  .then(function(response) {
                    if (self.hasPermissionExportData) {
                      if (response.body.status === 'wyeksportowany') {
                        let baseUrl = SettingsInstance.baseApiUrl.trim('/');
                        baseUrl +=
                          '/warstwy_wektorowe/eksport/by_uuid/' +
                          response.body.uuid;
                        window.location = baseUrl;
                      } else {
                        setTimeout(getExport, 3000);
                      }
                    }
                  })
                  .catch(function(err) {
                    self.$store.commit(WINDOW_API_ERROR_SHOW, err);
                  });
              }

              getExport();
            }
          }
        }
      }
    },
    async getExportId() {
      const api = new ApiWarstwy();
      let self = this;
      var exportId;
      let pointInThePast =
        this.$store.getters.featuresLayer && this.$store.getters.featuresLayer
          ? this.$store.getters.featuresLayer.pointInThePast
          : null;

      let body = {
        bbox: null,
        format: this.exportData.fileType,
        ids: null,
        uklad: self.$store.getters.coordinateSystem
      };

      if (pointInThePast) {
        body.date = moment.unix(pointInThePast).format('YYYY-MM-DD');
      }

      if (this.historyTab) {
        body.object_history = this.formatIds(this.historyTable);
      } else if (this.exportData.scope === this.scopes.selection) {
        body.ids = this.formatIds(this.selectedFeatures);
      }

      if (self.exportAvailable && self.hasPermissionExportData) {
        let response = await api
          .postWarstwyWektoroweByIdEksport({
            body: body,
            id: self.featuresLayer.id
          })
          .catch(function(err) {
            self.$store.commit(WINDOW_API_ERROR_SHOW, err);
          });

        if (response && response.body) {
          exportId = response.body.id;
        }
      }
      return exportId;
    },
    validateFormData() {
      let showAlert = false;
      let voivodeshipIsRequired =
        !this.historyTab && this.exportData.scope === this.scopes.all;
      let districtIsRequired = this.exportData.scope === this.scopes.all;
      let voivodeshipIsEmpty = this.exportData.voivodeship === null;
      this.dataErrors.fileTypeIsEmpty = !this.exportData.fileType;
      this.dataErrors.scopeIsEmpty = !this.historyTab && !this.exportData.scope;
      this.dataErrors.voivodeshipIsEmpty =
        voivodeshipIsRequired && voivodeshipIsEmpty;
      this.dataErrors.districtIsEmpty =
        districtIsRequired &&
        !(voivodeshipIsRequired && voivodeshipIsEmpty) &&
        this.exportData.district === null &&
        !this.exportData.allDistricts;
      for (var error in this.dataErrors) {
        if (this.dataErrors[error]) {
          showAlert = true;
          break;
        }
      }
      this.showAlert = showAlert;
      return !this.showAlert;
    },
    formatIds(ids) {
      return ids.reduce((previousValue, obj) => {
        let prefix = previousValue ? previousValue + ',' : previousValue;
        return prefix + obj.id;
      }, '');
    },
    async fetchDistricts(voivodeshipTeryt) {
      if (voivodeshipTeryt) {
        this.locked = true;
        const api = new ApiWyszukiwarka();

        let control = Date.now().toString();
        this.districtControl = control;
        var response = await api
          .getWyszukiwarkaAll({
            wso2_id: this.contextEmail ? this.contextEmail : null,
            orgid: this.contextOrganizationId
              ? this.contextOrganizationId
              : null,
            teryt: voivodeshipTeryt,
            woj: '',
            pow: '',
            gmi: '',
            control: control
          })
          .catch(e => {
            this.$store.commit(WINDOW_API_ERROR_SHOW, e);
            this.locked = false;
          });

        if (response.body.control === this.districtControl) {
          let districts = response.body.powiaty || [];
          districts = districts.map(x => {
            return {
              name: (x.nazwa || '').replace('powiat ', ''),
              value: x.teryt
            };
          });
          districts = districts.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
          );
          this.districts = districts;
        }

        this.locked = false;
      }
    },
    getDistrictExportPath(teryt) {
      let url = SettingsInstance.baseApiUrl.trim('/');
      url += `/warstwy_wektorowe/${this.featuresLayer.id}/pow/eksport/${teryt}`;
      return url;
    },
    getVoivodeshipExportPath(teryt) {
      let url = SettingsInstance.baseApiUrl.trim('/');
      url += `/warstwy_wektorowe/${this.featuresLayer.id}/woj/eksport/${teryt}`;
      return url;
    }
  }
};
</script>
